import React from 'react';

export function ResultEmptyHint({ children }: { children: React.ReactNode }) {
    return (
        <p className="text-xs text-muted-foreground border border-dashed border-border rounded-md px-3 py-2 bg-secondary/20">
            {children}
        </p>
    );
}
